/**
 * Renders lightweight inline markdown into HTML with strict HTML escaping first.
 * Supports: **bold**, _italic_, `code`, [label](https://...), paragraph breaks (\n\n), and line breaks (\n).
 */
export const renderInlineMarkdown = (input: string): string => {
  if (!input) return ''
  const escapeHtml = (raw: string) =>
    raw
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#39;')
  const escaped = escapeHtml(input)
  return escaped
    .replace(/\*\*([^*\n]+)\*\*/g, '<strong>$1</strong>')
    .replace(/(^|\s)_([^_\n]+)_/g, '$1<em>$2</em>')
    .replace(/`([^`\n]+)`/g, '<code>$1</code>')
    .replace(/\[([^\]\n]+)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2" target="_blank" rel="noreferrer">$1</a>')
    .replace(/\n{2,}/g, '</p><p>')
    .replace(/\n/g, '<br />')
    .replace(/^/, '<p>')
    .concat('</p>')
}
